import { env } from '../utils/env';

export const mapboxToken = env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export const isMapboxEnabled = Boolean(mapboxToken);
